import { Layout } from 'antd';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Footer, Header } from '@/components/organisms';
import { AdminSosList, AdminUsersList, Landing, MarketplaceEdit, MarketplaceList, MarketplaceMyFavourites, MarketplaceMyItems, MarketplaceNew, MarketplacePending, MarketplaceShow, NotFound, PaymentLink, ProductEnquiries, Profile, SosEdit, SosMessages, SosMySos, SosNew, SosPending, UsersList } from '@/components/pages';
import { AuthenticatedRoute, withAnalytics } from '@/routes';
import React from 'react';

import styles from './FrameView.module.css';
import { SosRejected } from '@/components/pages/SosRejected';

// Create wrapped components outside of render for better performance
const LandingWithAnalytics = withAnalytics(Landing);
const MarketplaceListWithAnalytics = withAnalytics(MarketplaceList);
const MarketplaceShowWithAnalytics = withAnalytics(MarketplaceShow);
const PaymentLinkWithAnalytics = withAnalytics(PaymentLink);
const NotFoundWithAnalytics = withAnalytics(NotFound);

const FrameView = () => (
    <>
        <Header />
        <Layout>
            <Layout.Content className={styles.content}>
                <Routes>
                    {/* Root route */}
                    <Route element={<LandingWithAnalytics />} path="/" />

                    {/* Profile */}
                    <Route element={<AuthenticatedRoute component={withAnalytics(Profile)} />} path="/profile" />

                    {/* Marketplace */}
                    <Route element={<MarketplaceListWithAnalytics />} path="/marketplace" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(MarketplaceNew)} />} path="/marketplace/new" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(MarketplaceMyItems)} />} path="/marketplace/my-items" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(MarketplaceMyFavourites)} />} path="/marketplace/my-favourites" />
                    <Route element={<AuthenticatedRoute component={MarketplacePending} role="admin" />} path="/marketplace/pending" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(MarketplaceEdit)} />} path="/marketplace/:id/edit" />
                    <Route element={<MarketplaceShowWithAnalytics />} path="/marketplace/:id" />

                    {/* SOS */}
                    <Route element={<Navigate replace to="/sos/new" />} path="/sos/create" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(SosNew)} />} path="/sos/new" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(SosMySos)} />} path="/sos/my-sos" />
                    <Route element={<AuthenticatedRoute component={SosPending} role="admin" />} path="/sos/pending" />
                    <Route element={<AuthenticatedRoute component={SosRejected} role="admin" />} path="/sos/rejected" />
                    <Route element={<AuthenticatedRoute component={withAnalytics(SosEdit)} />} path="/sos/:id/edit" />

                    {/* Admin */}
                    <Route element={<AuthenticatedRoute component={AdminSosList} role="admin" />} path="/admin/sos" />
                    <Route element={<AuthenticatedRoute component={AdminUsersList} role="admin" />} path="/admin/users" />
                    <Route element={<AuthenticatedRoute component={UsersList} role="admin" />} path="/admin/users-list" />
                    <Route element={<AuthenticatedRoute component={ProductEnquiries} role="admin" />} path="/admin/product-enquiries" />
                    <Route element={<AuthenticatedRoute component={SosMessages} role="admin" />} path="/admin/user-sos-statestics" />

                    {/* Other */}
                    <Route element={<PaymentLinkWithAnalytics />} path="/payment-link/:id" />

                    {/* Catch all route for 404 */}
                    <Route element={<NotFoundWithAnalytics />} path="*" />
                </Routes>
            </Layout.Content>
        </Layout>
        <Footer />
    </>
);

export { FrameView };
